import {
  PRODUCT_INFO_REQUEST,
  PRODUCT_INFO_SUCCESS,
  PRODUCT_INFO_FAILED,
  PRODUCT_INFO_CREATE,
  PRODUCT_INFO_CREATE_SUCCESS,
  PRODUCT_INFO_CREATE_FAILED,
  PRODUCT_INFO_DELETE,
  PRODUCT_INFO_DELETE_SUCCESS,
  PRODUCT_INFO_DELETE_FAILED,
  PRODUCT_INFO_EDIT,
  PRODUCT_INFO_EDIT_SUCCESS,
  PRODUCT_INFO_EDIT_FAILED,
  PRODUCT_INFO_STATE_CHANGE,
} from "../../../_utils/constants/ProductCatalog";


const initialState = {
  valueList: [],
  isLoading: false,
  isSuccess: false,
  isCreated: false,
  isDeleted: false,
  isEdited: false,
  errors: {},
};

const ProductInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case PRODUCT_INFO_REQUEST:
      return {
        ...state,
        isLoading: true,
        isSuccess: false,
        errors: {}
      }
    case PRODUCT_INFO_SUCCESS:
      var decryptedData = action.payload;
      return {
        ...state,
        valueList: decryptedData.result,
        isLoading: false,
        isSuccess: true,
        errors: {}
      }
    case PRODUCT_INFO_FAILED:
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
        errors: action.payload
      }
    case PRODUCT_INFO_CREATE:
      return {
        ...state,
        isLoading: true,
        isCreated: false,
        errors: {}
      }
    case PRODUCT_INFO_CREATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isCreated: true,
        errors: {}
      }
    case PRODUCT_INFO_CREATE_FAILED:
      return {
        ...state,
        isLoading: false,
        isCreated: false,
        errors: action.payload
      }

    case PRODUCT_INFO_DELETE:
      return {
        ...state,
        isLoading: true,
        isDeleted: false,
        errors: {}
      }
    case PRODUCT_INFO_DELETE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isDeleted: true,
        errors: {}
      }
    case PRODUCT_INFO_DELETE_FAILED:
      return {
        ...state,
        isLoading: false,
        isDeleted: false,
        errors: action.payload
      }
    case PRODUCT_INFO_EDIT:
      return {
        ...state,
        isLoading: true,
        isEdited: false,
        errors: {}
      }
    case PRODUCT_INFO_EDIT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isEdited: true,
        errors: {}
      }
    case PRODUCT_INFO_EDIT_FAILED:
      return {
        ...state,
        isLoading: false,
        isEdited: false,
        errors: action.error
      }

    case PRODUCT_INFO_STATE_CHANGE:
      return {
        ...state,
        isCreated: false,
        isDeleted: false,
        isEdited: false,
      }
  };
  return state;
};


export default ProductInfoReducer;